import { isProduction, isStg } from '../app-config/environment'
import { STG_ENV } from '../app-config/stg-env'

const PDF_REST_API_URL = {
  dev: 'https://pdfservice.dev.surecolabs.com',
  prod: 'https://pdfservice.docday.com'
}

export const getPdfRestApiUrl = () => {
  if (isStg()) {
    return STG_ENV.pdfServiceUrl
  }
  if (isProduction()) {
    return PDF_REST_API_URL.prod
  }
  return PDF_REST_API_URL.dev
}
